module.exports = __webpack_public_path__ + "assets/img/mecha-btn-3fda8964.png";